import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IconButtonComponent } from './icon-button.component';
@Component({
  selector: 'app-add-remove-button',
  imports: [ReactiveFormsModule, CommonModule, IconButtonComponent],
  template: `
    @if (hasValue) {
      <app-icon-button
        [ariaLabel]="removeAriaLabel"
        icon="fa-light fa-minus"
        (click)="onClick($event)"
      />
    } @else {
      <app-icon-button
        [ariaLabel]="addAriaLabel"
        icon="fa-light fa-plus"
        (click)="onClick($event)"
      />
    }
  `,
  styles: ``,
})
export class AddRemoveButtonComponent {
  @Input()
  addAriaLabel = 'Add';

  @Input()
  removeAriaLabel = 'Remove';

  @Input()
  hasValue = false;

  @Output()
  click = new EventEmitter();

  protected onClick(event: MouseEvent) {
    event.stopPropagation();
    this.click.emit();
  }
}
